import script from "./LocalModeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalModeBanner.vue?vue&type=script&setup=true&lang=js"

import "./LocalModeBanner.vue?vue&type=style&index=0&id=559b7ba5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559b7ba5"]])

export default __exports__